
export const config = {
    icon: "LetterH",
    options: [
        {
            tag: 'h1',
            icon: "TextHOne",
        },
        {
            tag: 'h2',
            icon: "TextHTwo",
        },
        {
            tag: 'h3',
            icon: "TextHThree",
        },
        {
            // label-style: matches BlockLabel label (UI_BODY_SM_DF + grey80)
            tag: 'h4',
            icon: "TextT",
            isBlockLabelStyle: true,
        },
        {
            // sublabel-style: matches BlockLabel sublabel (UI_CAPTION_DF + grey60)
            tag: 'h5',
            icon: "TextAa",
            isBlockLabelStyle: true,
        }
    ]
}
